<template>
	<joy-page :joyPageStatus="joyPageStatus">
	<div class="setHeightFullWhite">
		<van-cell :title="list.title"></van-cell>
		<div class="content">
			<video width="100%" controlslist="nodownload" :src='list.src' controls="controls" :poster="list.poster"></video>
		</div>
	</div>
	</joy-page>
</template>

<script>
	export default{
		data(){
			return{
				src:"",
				poster:"",
				title:"",
				joyPageStatus: '',
				list:'',
			}
		},
		methods:{
			loadData(){
				const that=this;
				this.joyPageStatus = 'loading';
				try{
					this.$axios.get('/train/info?id='+this.id).then(res => {
						if (res.data.code == 200) {
							this.joyPageStatus = 'success';
							let data=res.data.data.video_list;
							data.poster="http://img.jiarixiaodui.com/"+data.poster;
							data.src="http://img.jiarixiaodui.com/"+data.src;
							this.list=data;
							this.loading = false;
							this.finished = true;
							
						}
					})
				}catch(e){
					if (this.$mConfig.debug) {
						console.log(e);
					};
				}
			},
		},
		created() {
			this.id=this.$route.query.id;
			this.loadData();
		}
	}
</script>

<style scoped="scoped">
	.content {    
		background: #fff;
		padding: 15px;
		overflow: hidden;
		}
</style>
